export default __webpack_public_path__ + "static/media/Snd_LowerTUpDown.dccedd3c.mp3";